/* eslint-disable camelcase */
/* eslint-disable react/jsx-pascal-case */
import { MRT_GlobalFilterTextField } from 'material-react-table'

export const defaultCellSx = {
  borderLeft: 'none',
  borderRight: 'none',
}

export const defaultTableProperties = {
  renderTopToolbar: ({ table }) => (
    <div className='w-full flex flex-row gap-2 py-2'>
      <MRT_GlobalFilterTextField table={table} />
    </div>
  ),
  columnFilterDisplayMode: 'popover',
  enableStickyHeader: true,
  enableColumnOrdering: false,
  enableColumnPinning: false,
  enableColumnActions: false,
  enableColumnFilters: true,
  enableGlobalFilter: true,
  enableFullScreenToggle: false,
  enableHiding: false,
  enableDensityToggle: false,
  enableFacetedValues: true,
  positionToolbarAlertBanner: 'none',
  initialState: {
    showGlobalFilter: true,
  },
  muiSelectCheckboxProps: {
    color: 'primary',
  },
  muiTableContainerProps: {
    sx: { maxHeight: '100%', overflow: 'auto' },
  },
  muiToolbarAlertBannerProps: {
    sx: {
      marginBottom: '16px',
    },
  },
  muiTableHeadCellProps: {
    sx: {
      overflow: 'visible',
      ...defaultCellSx,
    },
  },
  muiTableHeadRowProps: {
    sx: {
      boxShadow: 'none',
      backgroundColor: 'rgba(249, 250, 251, 1)',
      '& .MuiTableCell-head': {
        fontWeight: '600',
        color: 'rgba(17, 24, 39, 1)',
      },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      fontFamily: 'inherit',
      color: 'rgba(23, 27, 58, 0.85)',
      overflow: 'visible',
      ...defaultCellSx,
    },
  },
  muiTableFooterCellProps: {
    sx: {
      borderLeft: 'none',
      borderRight: 'none',
    },
  },
  muiTablePaperProps: {
    sx: {
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      overflow: 'visible',
      borderRadius: '12px',
      border: '1px solid rgba(229, 231, 235, 1)',
    },
  },
  muiTableFooterProps: {
    sx: {
      boxShadow: 'none',
    },
  },
  displayColumnDefOptions: {
    'mrt-row-actions': {
      header: 'Settings',
      size: 100,
    },
  },
  positionGlobalFilter: 'left',
}

const config = { tableInstance: defaultTableProperties }
export default config
